import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { ITableColumnTags } from '../../../models/table';
import { Translates } from '../../ph-simple-table/translates';
import { Utils } from '../../../services/utils.service';
import { ProductCardService } from '../../../services/product-card.service';
import { Router } from '@angular/router';
import { SessionService } from '../../../services/session.service';
import { ProductCardTab } from '../../../../product/models/models';
import { EMPTY_PRODUCT_IMAGE_PATH } from '../../../services/products.service';

import { SHARED_MODULES } from '../../../../shared.';
import { SanitizerPipe } from '../../../pipes/sanitizer.pipe';
import { ColorTagsDirective } from '../../../directives/color-tags.directive';
import { PhTooltipDirective } from '../../../directives/ph-tooltip.directive';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

type ProductNameDtypeElement = {
	tags: ITableColumnTags;
	value: string;
	photo: string;
	clickable: boolean;
	is_master_position: boolean;
	is_archived: boolean;
	new_tab: boolean;
	tab_name: ProductCardTab;
}

@Component({
    selector: 'app-product-name-dtype',
    templateUrl: 'product-name-dtype.component.html',
    styleUrls: ['product-name-dtype.component.scss'],
	imports: [SHARED_MODULES, SanitizerPipe, ColorTagsDirective, PhTooltipDirective, PhIconComponent],
    standalone: true
})
export class ProductNameDtypeComponent implements OnInit {
	defaultPhotoUrl: string;
	element: ProductNameDtypeElement;
	key: number;
	translates = Translates;

	constructor(
		@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<ProductNameDtypeElement>,
		public productCardService: ProductCardService,
		private sessionService: SessionService,
		private translate: TranslateService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;
		this.key = this.elementInjected.key as number;
		this.defaultPhotoUrl = EMPTY_PRODUCT_IMAGE_PATH;

		if (this.elementInjected.isTranslate && this.translates[this.element.value])
			this.translate
				.get(this.translates[this.element.value])
				.subscribe((value: string) => this.element.value = value);
	}

	click(): void {
		if (this.element.clickable && !Utils.isNullOrUndefined(this.key)) {
			if (this.element.new_tab) {
				const link: string = this.router.serializeUrl(
					this.router.createUrlTree(
						this.sessionService.getLink(['product']),
						{ queryParams: { id: this.key, archive: this.element.is_archived ?? false } }
					)
				);
				window.open(link, '_blank');
			} else {
				this.productCardService.open({
					key: this.key,
					name: this.element.value,
					tab: this.element.tab_name
				});
			}
		}
	}
}
